import { CliClientsConsolePage } from "../../operator/console/cli-clients-console";

export default function ConsoleCliClientsRoute() {
  return <CliClientsConsolePage />;
}
